export enum AssetMetadataKey {
  PROVIDER_ASSET_ID = 'providerAssetId',
  FILL_COLORS = 'fillColors',
  STROKE_COLORS = 'strokeColors',
  QUANTIZED_COLORS = 'quantizedColors',
  BACKGROUND_REMOVAL_REFERENCE_ASSET_ID = 'app-background-removal:referenceAssetId',
  BACKGROUND_REMOVAL_HAS_BACKGROUND = 'app-background-removal:hasBackground',
  BACKGROUND_REMOVAL_USER_ID = 'app-background-removal:userId',
  IMAGE_ENHANCEMENT_REFERENCE_ASSET_ID = 'app-photo-enhanced:referenceAssetId',
  IMAGE_ENHANCEMENT_HAS_ENHANCED = 'app-photo-enhanced:hasEnhanced',
  IMAGE_ENHANCEMENT_USER_ID = 'app-photo-enhanced:userId',
}
